export enum TrafikCoveragesIds {
    TRAFIK = 2770001,
    PREMIESKATT = 2780001
}
export enum TrafikCoveragesNames {
    TRAFIK = 'Trafik, Kris'
}
export enum HalvCoveragesIds {
    TRAFIK = 277,
    PREMIESKATT = 278,
    DELKASKO = 279
}
export enum HalvCoveragesNames {
    TRAFIK = 'Trafik, Kris',
    FIREGLASSTHEFT = 'Brand, Glas, Stöld',
    RESCUE = 'Maskin, Räddning',
    LEGAL = 'Rättsskydd',
    ALLRISK = 'Allrisk bil'
}
export enum HelCoveragesIds {
    TRAFIK = 277,
    PREMIESKATT = 278,
    DELKASKO = 279,
    VAGNSKADA = 280
}
export enum HelCoveragesNames {
    TRAFIK = 'Trafik, Kris',
    FIREGLASSTHEFT = 'Brand, Glas, Stöld',
    RESCUE = 'Maskin, Räddning',
    LEGAL = 'Rättsskydd',
    ALLRISK = 'Allrisk bil',
    DAMAGE = 'Vagnskada'
}
export enum PlusCoveragesIds {
    PLUSPACKAGE = 1241
}
export enum TillagsCoveragesIds {
    HYRBILL = 281,
    ALLRISK = 817
}
export enum TillagsHyrbilCoverageIds {
    HYRBILL = 281
}
export enum TillagsAllRiskCoverageIds {
    ALLRISK = 817
}
